import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUIVersion } from "store/app";
import { useThemeUI } from "theme-ui";
import flow from "lodash/fp/flow";

import { Button } from "components";
import { ButtonWithImageOptions, IconButtonOptions } from "components/Forms";
import { ChevronLeftIcon } from "components/icons";

export default function GroupedIconButtonOptions({
  name,
  label,
  labelIcon,
  options,
  toolTip,
  defaultValue,
  value,
  onChange,
  isFieldTouched,
  setTouchedField,
  setFocusedField,
  goBackFocusedFields,
  defaultValueToSetOnRender,
  resetButtonOption,
}) {
  const {
    theme: { isMobile },
  } = useThemeUI();

  const UIVersion = useSelector(selectUIVersion);

  const [displayOptionsFor, setDisplayOptionsFor] = useState("");

  const machGoalieColorArr = [
    "Shaft Color code",
    "Paddle Color code",
    "Shoulder Decal Color code",
    "Shoulder Color code",
    "Outline Color code",
    "Spine Color code",
    "Bauer Logo Color code",
    "SUPREME Logo Color code",
  ];
  const hyperliteGoalieColorArr = [
    "Shaft Color code",
    "Paddle Color code",
    "Shoulder Decal Color code",
    "Mesh Color code",
    "Bauer Logo Color code",
    "HYPERLITE Logo Color code",
  ];
  const goalieHyperliteMobileCheck =
    hyperliteGoalieColorArr.includes(name) && isMobile;
  const goalieMachMobileCheck = machGoalieColorArr.includes(name) && isMobile;
  const goalieMobileCheckForColor =
    goalieHyperliteMobileCheck || goalieMachMobileCheck;
  const goBack = () => {
    setDisplayOptionsFor("");
    if (!goalieMobileCheckForColor) {
      goBackFocusedFields();
    }
  };

  const selectedOption = value?.selectedOption;

  useEffect(() => {
    if (displayOptionsFor !== "") {
      if (!goalieMobileCheckForColor) {
        setFocusedField();
      }
    }
  }, [displayOptionsFor]);

  // To distinguish between showing checkmark icon for
  // new goalie-gear but not existing products
  const parentShouldBeSelected =
    value?.parentLabelShouldShowIfItIsSelected &&
    value?.value &&
    isFieldTouched;

  // CSS in json will overwrite labelIcon
  labelIcon = selectedOption?.css && (labelIcon = selectedOption);

  return (
    <>
      {displayOptionsFor === "" && (
        <ButtonWithImageOptions
          options={[
            {
              label,
              value: label,
              iconAfter: selectedOption?.icon || labelIcon,
              toolTip: toolTip,
            },
          ]}
          onChange={flow(setDisplayOptionsFor, setTouchedField)}
          isSelected={parentShouldBeSelected}
        />
      )}

      {displayOptionsFor !== "" && (
        <IconButtonOptions
          name={name}
          options={options}
          defaultValue={defaultValue}
          value={value?.value}
          onChange={(v) => {
            if (v === value?.value) {
              goBack();
            }
            onChange(v);
          }}
          defaultValueToSetOnRender={defaultValueToSetOnRender}
          backButton={
            <Button
              variant="secondary"
              size={UIVersion === 2 && isMobile ? "medium" : "large"}
              iconBefore={<ChevronLeftIcon />}
              aria-label="go back"
              isRound
              onClick={goBack}
            />
          }
          resetButtonOption={resetButtonOption}
        />
      )}
    </>
  );
}
